<template>
  <div class="h-full rounded-xl p-px" :class="borderClass">
    <section
      class="relative h-full overflow-hidden rounded-xl bg-depth-1"
      :class="padded ? 'p-5' : ''"
    >
      <div
        class="pointer-events-none absolute z-0 rounded-full blur-3xl"
        :class="glowClass"
      ></div>
      <div class="relative">
        <slot />
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
type SectionCardVariant = 'accent' | 'brand';

const props = withDefaults(
  defineProps<{
    variant?: SectionCardVariant;
    padded?: boolean;
  }>(),
  {
    variant: 'accent',
    padded: true,
  },
);

const borderClass = computed(() =>
  props.variant === 'brand'
    ? 'bg-linear-to-br from-brand/50 via-transparent to-brand/50'
    : 'bg-linear-to-br from-accent-blue/50 via-transparent to-accent-blue/50',
);

const glowClass = computed(() =>
  props.variant === 'brand'
    ? '-top-10 -right-10 h-40 w-56 bg-brand/10 mix-blend-screen'
    : '-top-8 -right-8 h-36 w-48 bg-accent-blue/10 mix-blend-screen',
);
</script>
